import http from './http';

export function getAll() {
  return http.get('/ProjectImportRecord/GetAll');
}

export function del(query) {
  return http.delete('/ProjectImportRecord/Delete', query);
}